const ko = {
  // Navbar
  nav_why: 'Why',
  nav_system: 'System',
  nav_partnership: 'Partnership',
  nav_esg: 'ESG',
  nav_resources: 'Resources',
  nav_contact: 'Contact',

  // Hero
  hero_title: '숯불구이를\n산업화하다',
  hero_description: '참숯의 맛을 대량생산 가능한 식품시스템으로 !\n\n\u00a0 첫째, 세로 숯불구이 구조\n\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0둘째, 일일 1만팩 생산(생선기준)\n셋째, 냉장 5.5개월 유통',

  // Problem
  problem_hero_title: '왜 숯불구이는 산업화되지 못했을까?',
  problem_hero_sub: '숯불구이는 가장 인기있는 조리방식이지만 지금까지 대량생산이 어려웠습니다',
  problem_col1_title: '1. Problem',
  problem_col1_summary: '전통적인 숯불구이는 사람의 손기술과 소규모 조리에 의존해 왔습니다.',
  problem_col1_detail: '고기를 굽는 과정에서 기름이 숯에 떨어지면 연기와 유해물질이 발생할 수 있습니다.\n\n이 구조적인 한계 때문에 숯불구이는 오랫동안 수작업 방식에 머물렀고, 표준화된 품질의 대량 생산 시스템으로 발전하지 못했습니다.\n\n그래서 대부분의 식품기업은 숯불 대신 스팀 조리 방식을 사용합니다.',
  problem_col2_title: '2. Solution',
  problem_col2_summary: 'K-Grill183은 숯불구이의 구조 자체를 새롭게 설계했습니다.',
  problem_col2_detail: '숯을 좌우에 배치하고 식재료를 세로로 구워 기름이 숯에 떨어지지 않도록 만들었습니다.\n\n이로써 유해물질 발생을 줄이며, 연기는 없게 합니다.\n\n그 결과 참숯의 열이 고르게 전달됨으로써 균일한 품질의 구이가 가능하게 됩니다.',
  problem_col3_title: '3. Impact',
  problem_col3_summary: '숯불구이,\n이제\n산업이 됩니다.',
  problem_col3_list: '균일한 숯불 풍미\n유해물질 발생 최소화\n연기발생 Zero\n자동화 조리 시스템',
  problem_col3_production_label: '하루 생산량:',
  problem_col3_production: '생선 기준: 1만팩\n돼지고기 기준: 12,000팩(250g)\n닭 기준: 5,000마리',
  problem_col3_closing: '이제 숯불구이는\n식당의 조리 방식을 넘어\n식품 산업의 생산 시스템으로 확장됩니다.',

  // Innovation
  innovation_hero_title: '생산성을 높인 숯불구이 시스템',
  innovation_hero_sub: '특허 자동 숯불구이기로 표준화된 제품을 대량생산이 가능한\n조리 방식으로 바꾸었습니다',
  innovation_table_title: '숯불구이 생산 구조 변화',
  innovation_col1: '생산구조',
  innovation_col2: '기존 숯불구이',
  innovation_col3: 'K-Grill 183',
  innovation_c0_criteria: '생산 방식',
  innovation_c0_label: '수작업 숯불 조리',
  innovation_c0_value: '자동화 숯불구이 생산 시스템',
  innovation_c1_criteria: '생산 규모',
  innovation_c1_label: '소량 생산 구조',
  innovation_c1_value: '공장 단위 대량 생산 가능',
  innovation_c2_criteria: '생산성',
  innovation_c2_label: '작업자 숙련도 의존',
  innovation_c2_value: '일일 생선 기준 1만팩 생산 가능',
  innovation_c3_criteria: '유통구조',
  innovation_c3_label: '즉석 소비 중심',
  innovation_c3_value: '냉장 5.5개월 유통 → HMR·수출가능',
  innovation_c4_criteria: '식품 안전',
  innovation_c4_label: '기름 낙하로 유해물질 발생 가능',
  innovation_c4_value: '기름낙하 차단, 구조적 유해물질 저감 설계',
  innovation_c5_criteria: '비즈니스',
  innovation_c5_label: '외식 중심 산업',
  innovation_c5_value: '식품 제조 + 외식 + 글로벌 유통산업',
  innovation_c6_criteria: '시장 확장성',
  innovation_c6_label: '매장 확장 중심',
  innovation_c6_value: '대량 공급 시장(HMR · 급식 · 할랄)',
  innovation_video1: 'KGrill183 숯불구이 소개 영상',
  innovation_video2: 'KGrill183 숯불자동구이 소개 영상',

  // Market
  market_hero_title: '새로운 식품 시장을 열다',
  market_hero_sub: '숯불구이 HMR의 새로운 생산 시스템\n식품 산업으로 확장할 전략적 생산 파트너를 찾습니다',
  market_target0: 'HMR(구이)을 개발하는\n식품기업',
  market_target1: '급식용 생선구이를\n공급하는 기업',
  market_target2: '구이(생선, 돼지고기, 닭)메뉴\n프랜차이즈',
  market_target3: 'K-푸드(할랄) 수출 기업',

  // ESG
  esg_tagline: 'K-Grill183은',
  esg_title: '건강과 환경을 고려한\n조리 기술입니다',
  esg_cat0: '환경',
  esg_item0_0: '유해물질 감소',
  esg_item0_1: '연기 Zero',
  esg_item0_2: '음식 폐기 감소',
  esg_cat1: '사회',
  esg_item1_0: '국민 건강 기여',
  esg_item1_1: '급식 품질 개선',
  esg_cat2: '지배구조',
  esg_item2_0: '식품 생산 표준화',

  // Reference
  ref_title: '참고자료',
  ref_sub: 'K-Grill183의 기술과 성과를 확인하세요',
  ref_card0_title: '특허 문서',
  ref_card0_desc: '숯불자동구이기 기술 특허',
  ref_card1_title: '기술 자료',
  ref_card1_desc: 'K-Grill183 구이 영상',
  ref_card2_title: '인증서',
  ref_card2_desc: '식품 안전 인증',
  ref_card3_title: '연구 보고서',
  ref_card3_desc: 'PAHs 감소 효과 연구',
  ref_video_title: '숯불구이 영상',
  ref_video0: '고등어 구이',
  ref_video1: '3.5cm 두께 513g 삼겹살 구이',
  ref_video2: '1.5cm 두께 227g 삼겹살 구이',
  ref_patent_title: '특허증 등',
  ref_cert_title: '5.5개월 냉장보관 인증서',
  ref_articles_title: '연구보고서 및 관련 기사',
  ref_article0_title: '고기 먹을 때 석쇠는 필수… \'불맛\'에 길들여진 한국인들, 암 걸리기 쉽다?',
  ref_article1_title: '고온 직화 그릴 조리 시 PAH 생성의 가장 중요한 요인은 불꽃에 떨어지는 지방의 불완전 연소로 인한 연기이며, 육즙 및 연기 제거 처리를 통해 4종 PAH 합계를 최대 89%까지 줄일 수 있었다.',
  ref_article2_title: '수직형 가스 바비큐는 PAH(다환방향족탄화수소) 생성이 낮은 반면, 수평형 용암석 바비큐는 식품 종류와 조리 시간에 따라 발암물질인 벤조[a]피렌을 포함한 PAH 수치가 최대 30 μg/kg까지 높게 나타났다.',

  // Contact
  contact_title: '문의',
  contact_sub: 'K-Grill183에 대해 더 알고 싶으신가요?\n언제든지 연락주세요.',
  contact_name: '이름',
  contact_company: '회사명',
  contact_email: '이메일',
  contact_phone: '연락처',
  contact_message: '문의 내용',
  contact_submit: '문의하기',
  contact_submitting: '전송 중...',
  contact_success: '문의가 성공적으로 전송되었습니다. 빠른 시일 내에 연락드리겠습니다.',
  contact_error: '문의 전송에 실패했습니다. 다시 시도해주세요.',

  // Footer
  footer_tagline: '세로 숯불구이 기술로\n식품 산업의 미래를 만듭니다.',
  footer_contact: '연락처',
  footer_links: '바로가기',
  footer_link_problem: '문제',
  footer_link_innovation: '혁신',
  footer_link_market: '시장',
  footer_link_esg: 'ESG',
  footer_link_contact: '문의',
  footer_copyright: '© 2024 K-Grill183. All rights reserved.',
};

export default ko;
